module.exports = __webpack_public_path__ + "img/congress-bg.ea599817.webp";